
var sprite = require("C:/git/annenberg-petspace-petbook/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 11.75 9.91\" id=\"arrow-left-fancy\" ><title>Asset 2</title><g data-name=\"Layer 2\"><g data-name=\"Layer 1\"><path d=\"M5.37 9.91a1 1 0 0 1-.71-.29L0 5 4.66.29a1 1 0 0 1 1.42 1.42L2.84 5l3.24 3.2a1 1 0 0 1-.71 1.71z\"/><path d=\"M10.74 6H1.42a1 1 0 0 1 0-2h9.32a1 1 0 1 1 0 2z\"/></g></g></symbol>";
module.exports = sprite.add(image, "arrow-left-fancy");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-left-fancy.svg
// module id = 293
// module chunks = 1